import { createSelector } from 'reselect';
import {
  FAILURE as UPDATE_WIRE_SERVICE_FAILURE,
  selectError as selectUpdateWireServiceFailure,
} from 'services/updateWire';


export const selectUpdateWireFailure = createSelector(
  selectUpdateWireServiceFailure,
  (results) => results === UPDATE_WIRE_SERVICE_FAILURE
);



// WEBPACK FOOTER //
// ./src/components/TransferPanelWireDetails/selectors.js